import { render, staticRenderFns } from "./BrandFooter.vue?vue&type=template&id=211f0fcc&"
import script from "./BrandFooter.vue?vue&type=script&lang=js&"
export * from "./BrandFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports